import ReactDOM from "react-dom";
import App from "./App";
import store from "./Redux/store";
import { Provider } from "react-redux";
import { VendorProvider } from "./context/VendorContext";
import "./polyfills";

import process from "process";

if (typeof window !== "undefined") {
  window.process = process;
}

if (!process.env) {
  process.env = {};
}

ReactDOM.render(
  <Provider store={store}>
    <VendorProvider>
      <App />
    </VendorProvider>
  </Provider>,

  document.getElementById("root"),
);
